import request from '@/sheep/request';

// 自律项打卡主记录
export interface LimitCheckinRecords {
	id : number
	userProjectId ?: number
	userId ?: number
	projectId ?: number
	checkinDate ?: string
	checkinTime ?: string
	isCompensate ?: boolean
	status ?: boolean
	description ?: string
	createTime ?: any
}

// 创建自律项打卡主记录
export const createLimitCheckinRecords = async (data : Partial<LimitCheckinRecords>) => {
	return request({
		url: '/wish/limit-checkin-records/create',
		method: 'POST',
		data,
		custom: {
			auth: true,
			showSuccess: true,
			successMsg: '打卡成功'
		},
	});
}

// 更新自律项打卡主记录
export const updateLimitCheckinRecords = async (data : Partial<LimitCheckinRecords>) => {
	return request({
		url: '/wish/limit-checkin-records/update',
		method: 'PUT',
		data,
		custom: {
			auth: true,
			showSuccess: true,
			successMsg: '更新成功'
		},
	});
}

// 删除自律项打卡主记录
export const deleteLimitCheckinRecords = async (id : number) => {
	return request({
		url: '/wish/limit-checkin-records/delete',
		method: 'DELETE',
		params: { id },
		custom: {
			auth: true,
			showSuccess: true,
			successMsg: '删除成功'
		},
	});
}

// 批量删除自律项打卡主记录
export const deleteLimitCheckinRecordsList = async (ids : number[]) => {
	return request({
		url: '/wish/limit-checkin-records/delete-list',
		method: 'DELETE',
		params: { ids },
		custom: {
			auth: true,
			showSuccess: true,
			successMsg: '删除成功'
		},
	});
}

// 获得自律项打卡主记录
export const getLimitCheckinRecords = async (id : number) => {
	return request({
		url: '/wish/limit-checkin-records/get',
		method: 'GET',
		params: { id },
		custom: {
			auth: true
		},
	});
}

// 获得自律项打卡主记录分页
export const getLimitCheckinRecordsPage = async (params : any) => {
	return request({
		url: '/wish/limit-checkin-records/page',
		method: 'GET',
		params,
		custom: {
			auth: false
		},
	});
}